"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inline = void 0;
const util_1 = require("../../util");
const MdInlineParser_1 = require("./MdInlineParser");
const parsers_1 = require("./parsers");
exports.inline = new MdInlineParser_1.MdInlineParser({ parsers: (0, parsers_1.parsers)(util_1.dhe) });
